<template>

    <SubHeading :home="home" :tabs="tabs" :shorts="false" :currTab="currTab" @active="handleActive" />
    
    <!-- breadcrumbs -->
    <nav class="grey lighten-4 z-depth-0">
      <div class="container nav-wrapper">
        <div class="col s12">
          <router-link to="/" class="breadcrumb teal-text"><small> <i class="material-icons left">home</i> Dashboard</small></router-link>
          <span class="breadcrumb blue-grey-text pointable"><small>Billing Home</small></span>
        </div>
      </div>
    </nav>

     <br />

    <div class="container grey lighten-4 round">
      <!-- FilterBilling -->
      <FilterBilling @search="handleSearch" />
    </div>

    <!-- Top -->
    <div id="top"></div>

    <div class="container">

        <!-- <div class="row">
            <div class="col s12"> -->

                <!-- Review Marker -->
                <div id="review"></div>

                <!-- Claims -->
                <LoadingDiv v-if="!isReady" />

                <div v-else>
                    <div class="section black-text center">
                        <br />
                        <h5 v-if="searchTitle" v-html="searchTitle"></h5>
                        <h5 v-else>
                          <span class="black blue-text chip">Search <i class="tiny material-icons">check_circle</i></span> 
                          <span class="teal grey-text text-lighten-2 chip">Displaying Everything!</span>
                        </h5>
                    </div>

                    <div class="section">
                        <div class="card z-depth-0 grey lighten-4">
                            <div class="card-panel z-depth-0 grey lighten-5 z-depth-1 hide-on-small-only">
                                <div class="row">
                                    <div class="col s1">#</div>
                                    <div class="col s3">Claims <small>(type)</small></div>
                                    <div class="col s2">Encounter(s)</div>
                                    <div class="col s2">Sent</div>
                                    <div class="col s2">Stage</div>
                                    <div class="col s1">Payment</div>
                                    <div class="col s1"><br /></div>
                                </div>
                            </div>

                            <div class="progress" v-if="isLoading">
                                <div class="indeterminate"></div>
                            </div>

                            <!-- Main -->
                            <div class="card-panel" :class="{
                                'blue-grey lighten-5':
                                    (index + 1) % 2 === 1 && cluster.status !== 'q',
                                'red lighten-5': cluster.status === 'q',
                            }" v-for="(cluster, index) in clusters" :key="cluster.id">
                                <div class="row">
                                    <div class="col s1">
                                        <p>{{ numberBadge(index) }}</p>
                                    </div>
                                    <div class="col s4 m3">
                                        <h6>
                                            {{ toMonthYear(cluster.month_year) }} Claims
                                            <br />
                                            <small>({{ HMO }} <b>{{ cluster.scheme.name
                                            }}</b>)</small>
                                        </h6>
                                    </div>
                                    <div class="col s2">
                                        <p v-if="cluster.encounters.length > 1">
                                            {{ cluster.encounters.length }} visits
                                        </p>
                                        <p v-else>{{ cluster.encounters.length }} visit</p>
                                    </div>
                                    <div class="col s2">
                                        <p>
                                            <span class="chip yellow" v-if="cluster.status === 'q'">Unsubmitted</span>
                                            <span class="black-text" v-else><b>₦{{
                                                grossTotalSent(cluster.encounters)
                                            }}</b>
                                            </span>
                                        </p>
                                    </div>
                                    <div class="col s2 hide-on-small-only">
                                        <p>
                                            <span class="chip indigo lighten-4"
                                                v-if="cluster.status === 'p'">Pending</span>
                                            <span class="chip" v-if="cluster.status === 'q'">N/A</span>
                                            <span class="chip green lighten-4"
                                                v-if="cluster.status === 'r' || cluster.status === 'v'">Completed
                                            </span>
                                        </p>
                                    </div>
                                    <div class="col s1 hide-on-small-only">
                                        <p>
                                            <span class="chip" :class="{
                                                'chip teal lighten-4': paymentStatus(cluster)?.toLowerCase() === 'paid',
                                                'chip grey lighten-2': paymentStatus(cluster)?.toLowerCase() === 'pending',
                                                'chip indigo lighten-4': paymentStatus(cluster)?.toLowerCase() !== 'paid' && paymentStatus(cluster)?.toLowerCase() !== 'pending' && paymentStatus(cluster)?.toLowerCase() !== 'unsubmitted',
                                            }" v-if="cluster.status === 'r' || cluster.status === 'v'"> 
                                            {{
                                                        checkPaid(cluster) ? 'Paid' : 'Pending'
                                                }}   
                                            </span>

                                            <span class="chip"
                                                v-else>N/A
                                            </span>
                                        </p>
                                    </div>
                                    <div class="col s3 m1">
                                        <span v-if="cluster.status === 'q'">
                                            <a class="btn-floating pulse red right"><i class="material-icons"
                                                    title="review" @click="handleReview(cluster)">edit</i></a>
                                        </span>

                                        <span v-else>
                                            <a
                                                class="btn-floating btn-medium waves-effect waves-light light-blue lighten-2 right"><i
                                                    class="material-icons" @click="handleReview(cluster)"
                                                    title="details">chevron_right</i></a>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- <br /> -->

                        </div>
                    </div>

                    <div class="section center" v-if="!clusters.length && !isLoading">
                        <h6><br /><img class="responsive-img" src="@/assets/img/no-claim.png" width="256"
                                title="No claims found" />
                        </h6>
                    </div>

                    <PaginationDiv :payLoad="allPages" @newPage="handlePage" v-else />
                </div>
            <!-- </div>
        </div> -->
    </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import getItemsOfItems from "@/composables/getItemsOfItems";
import SubHeading from "@/components/HeaderSubDiv.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import PaginationDiv from "@/components/pager/PaginationDiv.vue";
import FilterBilling from "@/components/billing/FilterBillingComponent.vue";
import {
    capWordsFx,
} from "@/composables/fxLibrary/coreFx.js";
import {
    grossTotalSentFx,
    grossTotalApprovedFx,
    checkPaidFx,
    paymentStatusFx,
} from "@/composables/calFunction/cal";
import { getCache, addCache } from "@/composables/cache/cache";
import { HMO } from '@/laravel/config';


export default {
    name: "billingHome",
    components: { SubHeading, LoadingDiv, PaginationDiv, FilterBilling },
    setup() {
        const response = ref(null);
        const isReady = ref(false);
        const isLoading = ref(false);
        const error = ref(null);
        const currUrl = ref(null);
        const currHook = ref(null);
        const searchTitle = ref(null);
        const home = ref(null);
        const currTab = ref(null);
        const tabs = ref([]);
        const UIUpdate = ref(true);

        // vue router
        const router = useRouter();

        // store
        const store = useStore();

        // config
        const providerId = store.state?.user?.account?.id;

        // start
        onMounted(() => {
            // page name
            document.title = "All Claims Cluster | EasyHMO";
        });

        // menu
        onMounted(() => {
            // load tab
            tabs.value.push({ id: 1, name: "Billing", title: "All", icon: null, url: "billing", hash: null, });
            tabs.value.push({ id: 2, name: "Billing", title: "Review", icon: "edit", url: "billing", hash: "#review" });

            // set default
            currTab.value = tabs.value.find(x => x.title.includes("All"));
            // set home
            home.value = tabs.value.find(x => x.title.includes("All"));
        });

        // handle curr status
        const handleActive = (tab) => {
            // refer
            if (tab.hash) {
                router.push({ hash: tab.hash });
            } else {
                router.push({ name: tab.url });
            }
        };

        // numbering
        const numberBadge = (num) => {
            return (
                (allPages.value.current_page - 1) * allPages.value.per_page + num + 1
            );
        };

        //from functions
        const capWords = (val) => {
            return capWordsFx(val);
        };

        // total calculations (gross sent)
        const grossTotalSent = (encounters) => {
            return grossTotalSentFx(encounters);
        };

        // total calculations (gross approved)
        const grossTotalApproved = (encounters, db) => {
            return grossTotalApprovedFx(encounters, db);
        };

        // convert to Month & Year
        const toMonthYear = (val) => {
            let parts = val.split("_");
            let month = parseInt(parts[0]);
            let year = parseInt(parts[1]);
            let date = new Date(year, month - 1); // months are zero-indexed in JavaScript
            let monthName = date.toLocaleString("default", { month: "short" });
            return monthName + " " + year;
        };

        // payment status
        const checkPaid = (payment, repayment) => {
            return checkPaidFx(payment, repayment);
        };

        // payment status
        const paymentStatus = (cluster) => {
            return paymentStatusFx(cluster);
        };

        // get function
        const getItemsFromApi = (table, id) => {

            // get item from store (cache)
            let cache = getCache(`${table}/${id}`);

            if (cache?.length) {
                response.value = cache;
            }

            (async () => {
                const { res, err } = await getItemsOfItems(table, id);

                if (res.value) {
                    response.value = res.value.data;
                    // add cache
                    addCache(`${table}/${id}`, response.value);
                    // set isEmpty to false
                    // isEmpty.value = isEmpty.value && response.value.data.length ? false : true;
                } else {
                    error.value = err.value;
                }

                // page is ready, loading is complete
                isReady.value = true;
                isLoading.value = false;
            })();
        };


        // handle search (emitted from component)
        const handleSearch = (val) => {
            // start loading
            isLoading.value = true;
            // set current Url
            currUrl.value = val.currUrl;
            // set current Hook
            currHook.value = val.currHook;
            // set search title
            searchTitle.value = val.searchTitle;
            // get items from function
            getItemsFromApi(currUrl.value, `${providerId}${currHook.value}`);
        };

        // handle edit
        const handleReview = (cluster) => {
            router.push({ name: "billingView", params: { clusterId: cluster.id } });
        };

        // switch page
        const handlePage = (page) => {
            // start laoding
            isLoading.value = true;
            // go back up
            router.push({ hash: "#top" });
            // get new page items from function
            getItemsFromApi(currUrl.value, `${providerId}${currHook.value}&page=${page}`);
            // kill update
            UIUpdate.value = false;
        };

        // output results
        const clusters = computed(() => {
            if (!response.value) {
                return [];
            } else {
                return response.value.data; // get data portion
            }
        });

        // output pages
        const allPages = computed(() => {
            if (!response.value) {
                return [];
            } else {
                return response.value; // get all
            }
        });

        return {
            handleActive,
            home,
            currTab,
            tabs,
            capWords,
            numberBadge,
            grossTotalSent,
            grossTotalApproved,
            toMonthYear,
            checkPaid,
            paymentStatus,
            handlePage,
            handleSearch,
            handleReview,
            isReady,
            isLoading,
            error,
            searchTitle,
            clusters,
            allPages,
            HMO: HMO,
        };
    },
};
</script>

<style scoped>
.progress {
    margin-top: -15px;
}

.clickable {
    cursor: pointer;
    opacity: 1;
    transition: opacity 0.3s ease;
}

.clickable:hover {
    opacity: 0.8;
}

.pointable {
    cursor: default;
    opacity: 1;
    transition: opacity 0.3s ease;
}

.pointable:hover {
    opacity: 0.8;
}

.spacer {
    padding: 2px;
}

.pointer {
    cursor: default;
}

/* base class */
.tab-custom {
    color: #747373;
    border: 1px solid white;
    background-color: white;
    display: inline-block;
    cursor: pointer;
    margin: 0 0 -1px;
    padding: 15px 25px;
    font-weight: 600;
    text-align: center;
    border-bottom: 2px solid white;
}

.tab-custom:hover {
    color: #000000 !important;
}

/* Removed (re-added)
  color: #000000;
  border: 1px solid #ddd;
  background-color: #d1f3df; */
.tab-custom-active {
    color: #000000;
    border: 1px solid #ddd;
    background-color: #d1f3df;
    display: inline-block;
    cursor: pointer;
    margin: 0 0 -1px;
    padding: 15px 25px;
    font-weight: 600;
    text-align: center;
    border-bottom: 2px solid orange;
}

/* display */
.tab-custom-section {
    padding: 20px 0 0;
    border-top: 1px solid #ddd;
}
</style>
